'use client';

declare global {
  interface Window {
    /**
     * Set by non-game surfaces (partner arcade, root play.skillz.com) so
     * @sdk-mobile resolves the app-level pseudo-game (SKILLZ_APP_GAME_ID = 19369)
     * as the active game id off a `/partner/*` or `/` URL. @sdk-mobile stores
     * freeze getGameId() at module load, so this MUST be set before the first
     * @sdk-mobile import evaluates — see PartnerSDKProvider. A real `/games/N`
     * URL always takes precedence, so game routes are unaffected.
     */
    __SKILLZ_APP_GAME_ID__?: string;
  }
}

const getGameId = () => {
  if (typeof window === 'undefined') {
    console.log('Error: getGameId should only be used in client modules');
    return '0';
  }
  const match = window?.location.pathname.match(/\/games\/(\d+)/);
  if (match) return match[1];
  // Non-game surface fallback (partner/root); '0' when unset, as before.
  return window.__SKILLZ_APP_GAME_ID__ ?? '0';
};

export default getGameId;
